import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { IRequestData } from '@zet/customer/src/api/functions/customerAdditionStateMachine'
import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { webStates } from '@zet/customer/src/utils/addCustomerStates'
import { i18n } from '@zet/localization'
import { zetApi } from '@zet/network'
import { replaceLoginHash } from '@zet/utils/loginHash'

import { getFormatRequestData } from '../utils/getFormatRequestData'

const getAddCustomerNextState = async (requestData: IRequestData) => {
  const requestBody = getFormatRequestData(requestData)
  const { data } = await zetApi.post('customer/onboard', requestBody)
  if (data?.data) {
    return data.data
  } else {
    return data?.error
  }
}

export const useAddCustomerState = () => {
  const {
    setCustomerId,
    customerId: addCustomerId,
    variantId,
  } = useAddCustomerStore((store) => store)
  const navigation = useNavigation()
  const toast = useToast()
  return useMutation(getAddCustomerNextState, {
    onSuccess: (data, variables) => {
      if (data?.actionData?.hash) {
        replaceLoginHash(data?.actionData?.hash)
      }
      if (data?.actionData?.error?.code === 2025) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description:
            data?.actionData?.error?.message ||
            i18n.t('toastMessages.somethingWentWrong'),
          hideAfter: 3000,
        })
      }

      if (data?.code === 400) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description:
            data?.message || i18n.t('toastMessages.somethingWentWrong'),
          hideAfter: 3000,
        })
        return
      }
      const { lockedTill, customerId, reason } =
        // eslint-disable-next-line no-prototype-builtins
        data.hasOwnProperty('actionData') && data.actionData

      if (data?.lockedTill) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: data?.reason,
          hideAfter: 3000,
        })
      }

      if (lockedTill) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: reason,
          hideAfter: 3000,
        })
        return data?.actionData
      }

      if (data?.action) {
        if (data?.actionData?.customerId) {
          setCustomerId(data?.actionData?.customerId)
        }

        navigation.navigate(webStates[data?.action], {
          customerId: customerId || addCustomerId,
          customerName: variables.fullName,
          customerPhoneNumber: variables.phoneNumber,
          ...(variantId && { variantId }),
          ...(variantId && { categoryId: 15 }),
        })
      }
    },
    onError: (error: any) => {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description:
          error?.response?.data?.error?.message ||
          i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })
}
